/**
 * Check if we're running in a Vercel preview deployment
 * Preview deployments don't support passkeys due to domain/rpID requirements
 */
export function isPreviewDeployment(): boolean {
	// Client-side: check if we're on a Vercel preview domain
	if (typeof window !== "undefined") {
		const hostname = window.location.hostname;
		// Vercel preview URLs are like: project-name-abc123.vercel.app
		// Production would use a custom domain (set via BETTER_AUTH_URL)
		// Any .vercel.app domain that's not localhost is likely a preview
		if (hostname.includes(".vercel.app") && hostname !== "localhost") {
			// Check if we have a production URL configured that matches
			const productionUrl = process.env.NEXT_PUBLIC_BETTER_AUTH_URL;
			if (productionUrl) {
				try {
					const prodHostname = new URL(productionUrl).hostname;
					// If current hostname matches production, it's not a preview
					if (
						hostname === prodHostname ||
						hostname.replace(/^www\./, "") === prodHostname.replace(/^www\./, "")
					) {
						return false;
					}
				} catch {
					// Invalid URL, continue with preview check
				}
			}
			return true;
		}
		return false;
	}

	// Server-side: check environment variables
	// Check VERCEL_ENV explicitly
	if (process.env.VERCEL_ENV === "preview") {
		return true;
	}

	// If we have VERCEL_URL but no BETTER_AUTH_URL, we're likely in a preview
	// (production uses BETTER_AUTH_URL, previews use VERCEL_URL)
	if (process.env.VERCEL_URL && !process.env.BETTER_AUTH_URL) {
		return true;
	}

	return false;
}

/**
 * Check if passkeys are available in the current environment
 * Passkeys require a stable domain and don't work in preview deployments
 */
export function arePasskeysAvailable(): boolean {
	return !isPreviewDeployment();
}
